import { Integration, License, MPMIntegration, MPMLicense } from './types';

export const removeItemFromArray = <T>(item: T, array: T[]) => {
    const index = array.indexOf(item);
    array.splice(index, 1);
};

export const mpmIntegrationToIntegration = (
    integration: MPMIntegration
): Integration => ({
    name: integration.name,
    id: integration.id,
    licenseTypes: integration.licenseTypes.map((type) => type.name),
});

export const mpmLicenseToLicense = ({
    integrationId: string,
    ...license
}: MPMLicense): License => ({
    ...license,
    expireDate: license.expireDate?.split('T')[0],
});
